import { Truck, Check } from "lucide-react";
import { useCurrency } from "@/context/CurrencyContext";

export const FREE_DELIVERY_THRESHOLD = 40;
const THRESHOLD = FREE_DELIVERY_THRESHOLD;

export const FreeDeliveryBar = ({ subtotal = 0, className = "" }) => {
  const { format } = useCurrency();
  const qualified = subtotal >= THRESHOLD;
  const remaining = Math.max(0, THRESHOLD - subtotal);
  const pct = Math.min(100, Math.max(subtotal > 0 ? 4 : 0, (subtotal / THRESHOLD) * 100));

  return (
    <div className={className} data-testid="free-delivery-bar">
      <div className="flex items-center gap-2 text-[12px] sm:text-xs text-charcoal">
        {qualified ? (
          <>
            <Check className="w-4 h-4 text-[#c9a13a] shrink-0" strokeWidth={3} />
            <span data-testid="free-delivery-message">
              You've unlocked <span className="font-semibold">free UK delivery!</span>
            </span>
          </>
        ) : (
          <>
            <Truck className="w-4 h-4 text-[#c9a13a] shrink-0" />
            <span data-testid="free-delivery-message">
              You're <span className="font-semibold text-pink">{format(remaining)}</span> away from free UK delivery
            </span>
          </>
        )}
      </div>
      <div className="mt-2 h-2 w-full rounded-full bg-gray-100 overflow-hidden ring-1 ring-gray-100">
        <div
          data-testid="free-delivery-progress"
          className="h-full rounded-full transition-[width] duration-700 ease-out"
          style={{
            width: `${pct}%`,
            background: "linear-gradient(90deg, #d9b45f 0%, #f4e2a4 45%, #e6c877 70%, #cfa64a 100%)",
            boxShadow: "0 0 8px rgba(217,180,95,0.6)",
          }}
        />
      </div>
    </div>
  );
};
